import { useState } from 'react';

import type { ConsentStatus } from '@/api/queries/gdpr';

const TONE: Record<ConsentStatus, { bg: string; color: string; dot: string }> = {
  granted: { bg: '#dcfce7', color: '#15803d', dot: '#16a34a' },
  expiring: { bg: '#fef3c7', color: '#a16207', dot: '#d97706' },
  pending: { bg: '#dbeafe', color: '#1d4ed8', dot: '#2563eb' },
  withdrawn: { bg: 'var(--surface-2)', color: 'var(--text-3)', dot: 'var(--text-4)' },
};

interface Props {
  status: ConsentStatus;
  expiresAt?: string | null;
}

export function ConsentStatusPill({ status, expiresAt }: Props) {
  // Capture "now" once on mount — calling Date.now() during render is impure.
  const [now] = useState(() => Date.now());
  let label: string = status[0].toUpperCase() + status.slice(1);
  if (status === 'expiring' && expiresAt) {
    const daysLeft = Math.round(
      (new Date(expiresAt).getTime() - now) / (1000 * 60 * 60 * 24),
    );
    if (daysLeft < 0) {
      label = `Overdue · ${Math.abs(daysLeft)}d`;
    } else {
      label = `Expiring · ${daysLeft}d`;
    }
  }
  const tone = TONE[status];
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '2px 8px',
        borderRadius: 999,
        background: tone.bg,
        color: tone.color,
        fontSize: 12,
        fontWeight: 500,
      }}
    >
      <span
        style={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          background: tone.dot,
        }}
      />
      {label}
    </span>
  );
}
